import React, { useEffect, useState } from "react";
import EditTopicDetailModal from "./EditTopicDetailModal";
import Select from "react-select";
import ISO6391 from "iso-639-1";
import upploadImage from "../../../assets/images/upload-video.png";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addLectureVideo,
  deleteLectureVideo,
  discardLectureVideo,
  getLectureVideo,
  publishLectureVideo,
} from "../../../features/slices/lectureVideoManagement";
import { imageUpload } from "../../../features/slices/liveStream";
import { toastService } from "../../../utils/toastify";
import CommonPagination from "../../CommonPagination";
import DeleteModal from "../../DeleteModal";
import moment from "moment";
import LoaderForImage from "../../LoaderForImage";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile } from "@ffmpeg/util";
import VideoPlayer from "../../VideoPlayer";

const initailValue = {
  chapterId: "",
  courseId: "",
  lectureName: "",
  lessonMedia: { video: "", language: "English", duration: null },
  totalDuration: 0,
  deleteModal: false,
  indexValue: 0,
};

const AddLecture = () => {
  const [iState, setUpdateState] = useState(initailValue);
  const [chapterName, setChapterName] = useState("");
  const [showEditTopic, setShowEditTopic] = useState(false);
  const [editTopicData, setEditTopicData] = useState({});
  const [errors, setErrors] = useState({});
  const [courseVideo, setCourseVideo] = useState([
    { video: "", language: "English", duration: null },
  ]);
  const [imageLoader, setImageLoader] = useState(); // Change: Track loading per video
  const [page, setPage] = useState(1);

  const { state } = useLocation();
  const { chapterId, lessonMedia, lectureName, deleteModal, indexValue } =
    iState;
  const { lectureVideo, loading } = useSelector((state) => state?.lectureVideo);
  const dispatch = useDispatch();

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  useEffect(() => {
    if (chapterId)
      dispatch(getLectureVideo({ chapterId, page })).then((data) => {
        setUpdateState((prevState) => ({
          ...prevState,
          indexValue: data?.payload?.result?.[0]?.paginationData?.length,
        }));
      });
  }, [chapterId, page]);

  useEffect(() => {
    setChapterName(state?.chapterName);
    setUpdateState((prevState) => ({
      ...prevState,
      chapterId: state?._id || "",
      courseId: state?.courseId || "",
    }));
  }, [state]);

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!lectureName?.trim()) {
      formErrors.lectureName = "Chapter name is required.";
      isValid = false;
    }

    if (!lessonMedia?.video?.trim()) {
      formErrors.lectureVideos = "lecture video is required.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleChange = (e) => {
    setErrors((prev) => ({
      ...prev,
      [e.target.name]: "",
    }));
    setUpdateState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const compressVideo = async (file) => {
    console.log(
      "Original video size (before compression):",
      file.size / (1024 * 1024),
      "MB"
    );

    const ffmpeg = new FFmpeg({ log: true });
    await ffmpeg.load();

    const fileBuffer = await fetchFile(file);
    await ffmpeg.writeFile("input.mp4", fileBuffer);

    // Use a lower CRF value and resize for faster compression
    await ffmpeg.exec([
      "-i",
      "input.mp4",
      "-vcodec",
      "libx264",
      "-crf",
      "30",
      "-vf",
      "scale=1280:720",
      "output.mp4",
    ]);

    const outputData = await ffmpeg.readFile("output.mp4");

    const compressedVideo = new Blob([outputData.buffer], {
      type: "video/mp4",
    });
    console.log(
      "Compressed video size (after compression):",
      compressedVideo.size / (1024 * 1024),
      "MB"
    );

    return compressedVideo;
  };

  const handleCoursesMedia = async (value) => {
    setErrors((prev) => ({
      ...prev,
      lectureVideos: "",
    }));

    const file = value;

    if (file) {
      const formData = new FormData();

      // Show loader for this specific video
      setImageLoader(true);

      if (file.type.startsWith("video/")) {
        const video = document.createElement("video");
        video.preload = "metadata";
        video.src = URL.createObjectURL(file);

        video.onloadedmetadata = async () => {
          URL.revokeObjectURL(video.src); // Revoke object URL to free memory
          const durationInSeconds = video.duration;

          try {
            // Compress the video before upload
            // const compressedVideo = await compressVideo(file);

            // Append the compressed video to FormData
            formData.append("fileName", file);

            // Upload the compressed video
            const res = await dispatch(imageUpload(formData));

            if (res?.payload?.code === 200) {
              // Hide loader after the upload is complete
              toastService.success("Video uploaded successfully");
              setUpdateState((prev) => ({
                ...prev,
                lessonMedia: {
                  ...prev.lessonMedia,
                  duration: durationInSeconds,
                  video: res?.payload?.url,
                },
                totalDuration: durationInSeconds,
              }));
            } else {
              toastService.error("Video upload failed");
            }
          } catch (error) {
            console.error("Error during video compression or upload:", error);
            toastService.error("Video compression or upload failed");
          } finally {
            setImageLoader(false); // Hide loader after processing
          }
        };

        video.onerror = () => {
          setImageLoader(false); // Hide loader in case of error
          toastService.error("Invalid video file");
        };
      } else {
        setImageLoader(false);
        toastService.error("Unsupported file type. Please upload a video.");
      }
    }
  };

  const addlectures = () => {
    if (validateForm()) {
      dispatch(addLectureVideo(iState)).then((data) => {
        if (data?.payload?.code == 200) {
          toastService.success("Video added successfully");
          dispatch(getLectureVideo({ chapterId })).then((data) => {
            setUpdateState((prevState) => ({
              ...prevState,
              indexValue: data?.payload?.result?.[0]?.paginationData?.length,
            }));
          });

          setUpdateState((prev) => ({
            ...prev,
            lessonMedia: { video: "", language: "", duration: null },
            lectureName: "",
            totalDuration: 0,
            deleteModal: false,
          }));
        } else {
          toastService.error("Video addition failed");
        }
      });
    }
  };
  const hanldeClose = () => {
    setUpdateState((prev) => ({
      ...prev,
      deleteModal: false,
    }));
  };
  const showDeleteModal = (res) => {
    setEditTopicData(res);
    setUpdateState((prev) => ({
      ...prev,
      deleteModal: true,
    }));
  };
  const handleDelete = () => {
    dispatch(
      deleteLectureVideo({ status: "Deleted", id: editTopicData?._id })
    ).then((res) => {
      if (res?.payload?.code === 200) {
        toastService.success("Video deleted successfully");
        dispatch(getLectureVideo({ chapterId })).then((data) => {
          setUpdateState((prevState) => ({
            ...prevState,
            indexValue: data?.payload?.result?.[0]?.paginationData?.length,
          }));
        });
        setUpdateState((prev) => ({
          ...prev,
          deleteModal: false,
        }));
      } else {
        toastService.error("Video deletion failed");
      }
    });
  };

  const handlePublish = () => {
    dispatch(publishLectureVideo({ chapterId })).then((response) => {
      if (response?.payload?.code == 200) {
        toastService.success("Lecture published successfully");
      } else {
        toastService.error("Lecture publishing failed");
      }
    });
  };
  const handleDiscard = () => {
    dispatch(discardLectureVideo({ chapterId })).then((res) => {
      if (res?.payload?.code == 200) {
        dispatch(getLectureVideo({ chapterId, page })).then((data) => {
          setUpdateState((prevState) => ({
            ...prevState,
            indexValue: data?.payload?.result?.[0]?.paginationData?.length,
          }));
        });
        toastService.success("Lecture discard successfully");
      } else {
        toastService.error("Lecture discard failed");
      }
    });
  };
   const handleChangeEmbeddedVideo = (e) => {
     setErrors((prev) => ({
       ...prev,
       lectureVideos: "",
     }));
     setUpdateState((prev) => ({
       ...prev,
       lessonMedia: {
         ...prev.lessonMedia,
        //  duration: durationInSeconds,
         video: e?.target?.value,
       },
      //  totalDuration: durationInSeconds,
     }));
   };
  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="TitleBox Border">
              <h4 className="Title">Add Lecture</h4>
            </div>
            <div className="CommonForm">
              <div className="form-group">
                <label>Course Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Course name"
                  name="lectureName"
                  value={chapterName}
                  disabled
                />
              </div>
              <div className="form-group">
                <label>Lecture Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter lecture name"
                  name="lectureName"
                  value={lectureName}
                  onChange={handleChange}
                />
                {errors.lectureName && (
                  <p className="d-flex justify-content-start text-danger mt-2 ">
                    {errors.lectureName}
                  </p>
                )}
              </div>
            </div>
            <div>
              <div className="TitleBox Border">
                <h4 className="Title">Course &amp; Video</h4>
              </div>
              <div className="form-group">
                <label>Embedded Video</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Embedded Video Url"
                  onChange={handleChangeEmbeddedVideo}
                  name="embeddedVideo"
                  value={lessonMedia?.video}
                />
                {/* {errors.courseMedia.video && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.courseMedia.video}
                </p>
              )} */}
              </div>
              <div className="CommonForm">
                {imageLoader ? (
                  <LoaderForImage />
                ) : (
                  <div
                    className="UploadBox Image"
                    style={{ position: "relative", zIndex: 0 }}
                  >
                    <span>
                      {!lessonMedia.video && (
                        <img src={upploadImage} alt="Upload" />
                      )}
                      {lessonMedia.video && (
                        <>
                          <VideoPlayer
                            url={lessonMedia?.video}
                            divHeight="110px"
                            setUpdateState={setUpdateState}
                            divStyle={{
                              height: "100%",
                              position: "absolute",
                              top: "0",
                              left: "0",
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              zIndex: 1,
                            }}
                          />
                          <i
                            className="fas fa-edit"
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              color: "#fff",
                              background: "rgba(0, 0, 0, 0.6)",
                              borderRadius: "50%",
                              padding: "5px",
                              zIndex: 2,
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              document.querySelector(`#file-input`).click()
                            }
                          />
                        </>
                      )}
                    </span>

                    <input
                      id={`file-input`}
                      type="file"
                      name="video"
                      accept=".mp4"
                      style={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        width: "100%",
                        height: "100%",
                        opacity: 0,
                        zIndex: lessonMedia.video ? 0 : 2,
                        cursor: "pointer",
                      }}
                      onChange={(e) => handleCoursesMedia(e.target.files[0])}
                    />
                    {!lessonMedia.video && (
                      <p>
                        <label>Click to upload</label> or <br /> drag &amp; drop
                      </p>
                    )}
                  </div>
                )}
                {errors.lectureVideos && (
                  <p className="d-flex justify-content-start text-danger mt-2 ">
                    {errors.lectureVideos}
                  </p>
                )}
              </div>
            </div>

            <button className="Button" onClick={addlectures}>
              Add Lecture
            </button>
            <div className="TableList mt-4">
              <table className="table-hover">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Lecture Id</th>
                    <th>Video</th>
                    <th>Duration</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {lectureVideo?.result?.[0]?.paginationData
                    ?.slice()
                    ?.reverse()
                    ?.map((res, i) => {
                      return (
                        <tr key={res?._id}>
                          <td>{i + 1}</td>
                          <td>{res?.lesson_number}</td>
                          <td>
                            {res?.lessonMedia?.map((data, i) => {
                              return (
                                <>
                                  <p className="BlueLink ml-0">{data?.video}</p>

                                  <br />
                                </>
                              );
                            })}
                          </td>
                          <td>
                            {res?.lessonMedia?.map((data, i) => {
                              return (
                                <>
                                  <a>
                                    {isNaN(data?.duration)
                                      ? ""
                                      : Math.floor(data?.duration) + " sec"}
                                  </a>

                                  <br />
                                </>
                              );
                            })}
                          </td>
                          <td>
                            <div className="Actions">
                              <a
                                className="Edit"
                                onClick={() => {
                                  setShowEditTopic(true);
                                  setEditTopicData(res);
                                }}
                              >
                                <i className="fa-regular fa-pen-to-square" />
                              </a>
                              <a
                                className="Delete"
                                onClick={() => showDeleteModal(res)}
                              >
                                <i className="fa-regular fa-trash-can" />
                              </a>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div className="Pagination">
              {lectureVideo?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <>
                  <p>
                    Showing {(page - 1) * 10 + 1} to{" "}
                    {lectureVideo?.result?.[0]?.paginationData?.length +
                      (page - 1) * 10}{" "}
                    of {lectureVideo?.result?.[0]?.totalCount?.[0]?.count}{" "}
                    results
                  </p>
                  <div className="PaginationRight">
                    <CommonPagination
                      activePage={page}
                      itemsCountPerPage={10}
                      totalItemsCount={
                        lectureVideo?.result?.[0]?.totalCount?.[0]?.count || 0
                      }
                      pageRangeDisplayed={4}
                      onChange={handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </div>
                </>
              )}
            </div>
            <button className="Button Discard" onClick={handleDiscard}>
              Discard
            </button>
            <button className="Button" onClick={handlePublish}>
              Publish
            </button>
          </div>
        </div>
      </div>
      {showEditTopic && (
        <EditTopicDetailModal
          setShowEditTopic={setShowEditTopic}
          editTopicData={editTopicData}
          lectureName={lectureName}
        />
      )}
      {deleteModal && (
        <DeleteModal
          hanldeClose={hanldeClose}
          handleDelete={handleDelete}
          statement={"video lecture"}
        />
      )}
    </>
  );
};

export default AddLecture;
